import { ls } from '../../Helpers/LocalStorage';
import Cryptlib from "cryptlib";
import { REACT_APP_ENCRYPT_KEY, REACT_APP_LICENSE_KEY } from '../processENV';

/**
 * Encrypt the json object and store into localstorage
 * @param {string} key Localstorage Key
 * @param {object} data Localstorage data - json object
 */
export function encryptAndStoreInLocalStorage(key, data) {
    let ecytData = encrypt(JSON.stringify(data), key);
    let encryptedKey = encrypt(key, REACT_APP_LICENSE_KEY);
    ls.setItem(encryptedKey, ecytData);
    return true;
}

/**
 * Decrypt the json object and retive data from localstorage
 * @param {string} key Localstorage Key
 */
export function getFromLocalStorageAndDecrypt(key) {
    let encryptedKey = encrypt(key, REACT_APP_LICENSE_KEY);
    let lsData = ls.getItem(encryptedKey);
    try {
        let dcypData = decrypt(lsData, key);
        return JSON.parse(dcypData);
    } catch (error){
        return lsData;
    }    
}

/**
 * Encrypt the json object and store into session storage
 * @param {string} key Session storage Key
 * @param {object} data Session storage data - json object
 */
 export function encryptAndStoreInSessionStorage(key, data) {
    let ecytData = encrypt(JSON.stringify(data), key);
    let encryptedKey = encrypt(key, REACT_APP_LICENSE_KEY);
    sessionStorage.setItem(encryptedKey, ecytData);
    return true;
}

/**
 * Decrypt the json object and retive data from session storage
 * @param {string} key Session storage Key
 */
export function getFromSessionStorageAndDecrypt(key) {
    let encryptedKey = encrypt(key, REACT_APP_LICENSE_KEY);
    let lsData = sessionStorage.getItem(encryptedKey);
    try {
        let dcypData = decrypt(lsData, key);
        return JSON.parse(dcypData);
    } catch (error){
        return lsData;
    }    
}

export function deleteItemFromLocalStorage(key) {
    let encryptedKey = encrypt(key, REACT_APP_LICENSE_KEY);
    localStorage.removeItem(encryptedKey);
}

export function deleteItemFromSessionStorage(key) {
    let encryptedKey = encrypt(key, REACT_APP_LICENSE_KEY);
    sessionStorage.removeItem(encryptedKey);
}

const encrypt = (data, key) => {
    const encryptKey = Cryptlib.getHashSha256(key, 32);
    return Cryptlib.encrypt(encodeURIComponent(data), encryptKey, REACT_APP_ENCRYPT_KEY);
};
  
const decrypt = (data, key) => {
    const decryptKey = Cryptlib.getHashSha256(key, 32);
    return decodeURIComponent(Cryptlib.decrypt(data, decryptKey, REACT_APP_ENCRYPT_KEY));
};


// LocalStorage Operations

/**
 * Store data in localStorage
 * @param {string} key - The key to store the data under
 * @param {any} value - The value to store
 * @returns {void}
 */
export const storeInLocalStorage = (key, value) => {
  try {
    const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
    localStorage.setItem(key, stringValue);
  } catch (error) {
    console.error(`Error storing data in localStorage for key ${key}:`, error);
  }
};

/**
 * Get data from localStorage
 * @param {string} key - The key to retrieve data for
 * @param {boolean} parseJson - Whether to parse the result as JSON (default: false)
 * @returns {any} The retrieved value or null if not found
 */
export const getFromLocalStorage = (key, parseJson = false) => {
  try {
    const value = localStorage.getItem(key);
    
    if (!value) return null;
    
    if (parseJson) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
    
    return value;
  } catch (error) {
    console.error(`Error getting data from localStorage for key ${key}:`, error);
    return null;
  }
};

/**
 * Delete data from localStorage
 * @param {string} key - The key to delete
 * @returns {void}
 */
export const removeFromLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing data from localStorage for key ${key}:`, error);
  }
};

/**
 * Update data in localStorage
 * @param {string} key - The key to update
 * @param {any} value - The new value
 * @param {boolean} mergeObjects - Whether to merge with existing object if both are objects (default: false)
 * @returns {any} The updated value
 */
export const updateInLocalStorage = (key, value, mergeObjects = false) => {
  try {
    if (mergeObjects) {
      // Try to get existing data
      const existingData = getFromLocalStorage(key, true);
      
      // If both existing and new data are objects, merge them
      if (existingData && typeof existingData === 'object' && typeof value === 'object') {
        const mergedData = { ...existingData, ...value };
        storeInLocalStorage(key, mergedData);
        return mergedData;
      }
    }
    
    // Simple update (overwrite)
    storeInLocalStorage(key, value);
    return value;
  } catch (error) {
    console.error(`Error updating data in localStorage for key ${key}:`, error);
    return null;
  }
};

/**
 * Check if a key exists in localStorage
 * @param {string} key - The key to check
 * @returns {boolean} Whether the key exists
 */
export const existsInLocalStorage = (key) => {
  return localStorage.getItem(key) !== null;
};

/**
 * Clear all data from localStorage
 * @returns {void}
 */
export const clearAllLocalStorage = () => {
  try {
    localStorage.clear();
    console.log('All localStorage data has been cleared');
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
};

